import { Switch } from "@/components/ui/switch"
import { WorkflowStatus } from "@/constants/workflows/workflows"

export const StatusToggle = ({
  status,
  onChange
}: {
  status: string,
  onChange: () => void
}) => (
  <Switch
    className="cursor-pointer"
    checked={status === WorkflowStatus.ACTIVE}
    onCheckedChange={() => onChange()}
  />
)
